import { MENU_CONTAINER, MENU_DRAGGABLE_CONTAINER } from "constants/widgetTypes.jsx";
import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";
const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;

export async function renderMenuWidget(context, widget, parent, override = null) {

    // <div class="widget menu_widget">
    const el = context.document.createElement("div");
    el.classList.add("widget", "menu_widget");

    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getMenuStyles(widget, breakpoint)
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(el);

    // Background (same behavior as Java BackgroundRenderer)
    renderBackground(context, widget, el);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false || (breakpoint === "mobile" && [MENU_DRAGGABLE_CONTAINER, MENU_CONTAINER].includes(child.type))) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, el);
    }

    return el;
}


function getMenuStyles(widget, breakpoint) {
    const styles = {};

    const props = widget?.properties?.[breakpoint];
    if (!props) return styles;

    const padding = props.padding ?? 0;

    styles.padding = `${padding}px`;
    styles.width = breakpoint === "desktop" ? "1200px" : "375px";

    return styles;
}